// =============================================================================
// Project:        Nifty Finance
// Filename:       index.js
// Description:    Main application entry point. Renders the React app to root
//                 DOM element and wraps app in HelmetProvider for async
//                 document head management. Global CSS imports here. Calls
//                 web vitals reporting if configured.
//
// Copyright (c) 2025 Nifty Finance. All rights reserved.
//
// License:        Proprietary and confidential. Unauthorized copying,
//                 distribution, modification, or use, in whole or in part,
//                 is strictly prohibited. For internal business use only.
//                 Contact hello@niftyfinance.com for licensing inquiries.
//
// Contact:        hello@niftyfinance.com | https://niftyfinance.com
//
// -----------------------------------------------------------------------------
// Developer Context:
// -----------------------------------------------------------------------------
// - Entrypoint for CRA (Create React App) bundle. Mounts <App /> to #root.
// - HelmetProvider wraps entire app for <Helmet> async support.
// - Global styles imported from index.css. Place only app-wide CSS here.
// - `reportWebVitals()` logs Core Web Vitals; wire up as needed for analytics.
// - No business logic in this file—app logic in App.js and children.
// - Only update if changing top-level wrappers, providers, or mounting method.
//
// -----------------------------------------------------------------------------
// Changelog:
// -----------------------------------------------------------------------------
// Date      | Version     | Author                      | Changes
// -----------|---------|----------------------|--------------------------------------
// 2025-07-05 | 1.0.0   | Trevor Bissonette    | Initial production version.
//
// -----------------------------------------------------------------------------
// Version Control:
// -----------------------------------------------------------------------------
// Version     : 1.0.0
// Last Update : 2025-07-05
// Repo        : https://github.com/NiftyFinance/Nifty
// =============================================================================







import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { initAnalytics, bootstrapAttribution } from './analytics';

initAnalytics({ sendPageView: false });
bootstrapAttribution(); 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
